import { useNavigate } from 'react-router-dom';

import Button from '@/components/Button/Button';
import CustomImage from '@/components/CustomImage';
import { useFormatText } from '@/hooks/useFormatText';

const PasswordSuccess = () => {
  const navigate = useNavigate();
  const { formatText } = useFormatText();
  return (
    <div className="flex flex-col justify-center p-15 md:p-10 w-full lg:max-w-150">
      <div className="w-full h-full flex flex-col items-center my-auto space-y-10">
        <CustomImage
          src={'/assets/svg/tick-mark.svg'}
          alt={'Success Illustration'}
          className="w-25 h-25"
        />
        <div>
          <p className="pb-2 text-center text-4xl max-md:text-3xl font-bold text-neutral-primary">
            {formatText('password-success.title')}
          </p>
          <p className="text-neutral-secondary text-center text-lg font-medium">
            {formatText('password-success.sub-title')}
          </p>
        </div>

        <Button
          label={formatText('password-success.actions.back-to-login')}
          variant="outline"
          className="w-full py-3.5 cursor-pointer hover:text-neutral-800"
          onClick={() => navigate('/login')}
        />
      </div>
    </div>
  );
};

export default PasswordSuccess;
